import React from "react";
import { useSelector } from "react-redux";
import { ConfigProvider } from "antd";
import { ThemeProvider } from "styled-components";
import { Layout } from "antd";
import CrmWrapper from "./style/CrmWrapper.style";
import ToDoList from "./components/toDoList";
import { getCurrentTheme } from "../../themes";

const { Header, Footer, Sider, Content } = Layout;

const CrmTemplate = (props) => {
  const { children, hasTabs } = props;
  const currentAppLocale = useSelector((state) => state.user.currentAppLocale);
  const theme = useSelector((state) => state.user.theme);
  const direction = useSelector(
    (state) => state.user.currentAppLocale.direction
  );
  const crmPalette = {
    colorPrimary: "#00b96b",
    linkColor: "#00b96b",
    colorLink: "#00b96b",
    fontFamily: "Rubik",
    bodyBackground: "#1c2125",
    componentBackground: "#282d33",
    borderRadiusBase: "4px",
    borderColorBase: "#d9d9d9",
    textColor: "#000000",
    textColorSecondary: "#546e7a",
    layoutBodyBackground: "#f3f6f8",
    inputBg: "#f9f9f9",
    inputBorderColor: "#f3f6f8",
    inputNumberBorderColor: "#f3f6f8",
    inputNumberHandlerBorderColor: "#f3f6f8",
    pickerBg: "#f9f9f9",
    pickerBorderColor: "#f3f6f8",
    selectBackground: "#f9f9f9",
    selectBorderColor: "#f3f6f8",
    labelRequiredColor: "#5850ec",
    labelColor: "rgba(13, 22, 46, 0.74)",
    disabledBg: "#ffffff",
    disabledColor: "rgba(0, 0, 0, 0.75)",
  };
  return (
    <ConfigProvider
      locale={currentAppLocale.antd}
      direction={currentAppLocale.direction}
      theme={{
        token: crmPalette,
      }}
    >
      <ThemeProvider theme={getCurrentTheme(theme, crmPalette)}>
        <CrmWrapper direction={direction} hasTabs={hasTabs}>
          <Layout style={{ height: "100%" }}>
            <Layout style={{ height: "100%" }}>
              <Content>{children}</Content>
            </Layout>
          </Layout>
        </CrmWrapper>
      </ThemeProvider>
    </ConfigProvider>
  );
};
export default CrmTemplate;
